import * as request from '@/utils/request'

export default {
  /**
   * @description 获取日志文件列表
   * @returns {Promise}
   */
  getFileLogFiles() {
    return request.post('/file_log/files', {})
  },
  /**
   * @description 查询日志内容
   * @param data {filename, channel, level, keyword, date_from, date_to, page, page_size}
   * @returns {Promise}
   */
  getFileLogList(data) {
    return request.post('/file_log/list', data)
  },
  /**
   * @description 下载日志文件
   * @param {string} filename
   * @returns {Promise}
   */
  downloadFileLog(filename) {
    return request.postBlob('/file_log/download', { filename: filename })
  }
}
